var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg36547E213B66Ab504Bd1E4B565E1F72D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.0559 63.4099L82.3599 81.2414C85.4282 74.1405 79.6664 64.3302 68.4017 58.2827C56.0314 51.6432 41.7184 52.0558 36.4333 59.2023C35.9644 59.835 35.5793 60.5032 35.2786 61.1965L42.9747 43.365C43.2753 42.6717 43.6604 42.0034 44.1294 41.3708C49.4195 34.2298 63.7325 33.8172 76.0977 40.4512C87.3624 46.4986 93.1242 56.3089 90.0559 63.4099Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.612 30.3075C105.672 42.1473 115.902 62.0824 106.465 74.8295C97.0226 87.5818 71.4931 88.3129 49.433 76.4731C27.3729 64.6333 17.1372 44.7034 26.5742 31.9562C36.0168 19.204 61.5519 18.4677 83.612 30.3075ZM56.9372 66.3291C69.3025 72.9631 83.6154 72.5505 88.9056 65.4095C94.1958 58.2686 88.4618 47.0958 76.0915 40.4562C63.7212 33.8167 49.4082 34.2293 44.1231 41.3758C38.8329 48.5167 44.5669 59.6896 56.9372 66.3291Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.52 71.2689L100.824 89.1004C100.288 90.3346 99.6052 91.5305 98.7701 92.6611C89.3275 105.413 63.7979 106.144 41.7379 94.3047C21.6385 83.5209 11.3563 66.0116 16.8255 53.3485L24.5164 35.5114C19.0467 48.1852 29.3295 65.6838 49.4288 76.4676C71.4889 88.3074 97.024 87.5712 106.461 74.824C107.307 73.6938 107.984 72.5031 108.52 71.2689Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 41.0718,
    y1: 56.3893,
    x2: 86.1537,
    y2: 63.8561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BF6E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 31.1999,
    y1: 46.692,
    x2: 98.5562,
    y2: 53.8388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BF6E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 20.4831,
    y1: 60.0833,
    x2: 92.8116,
    y2: 67.7476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2BF6E7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg36547E213B66Ab504Bd1E4B565E1F72D);
export default __webpack_public_path__ + "static/media/36547e213b66ab504bd1e4b565e1f72d.c7b307e3e10cd6699b088da46c4b0c9f.svg";
export { ForwardRef as ReactComponent };